import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../context/AuthContext';
import { apiGet } from '../../services/apiFetch';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  useEffect(() => {
    const validateSession = async () => {
      const { status } = await apiGet('/api/auth/session');

      if (status === 401) {
        if (location.pathname !== '/login') {
          navigate('/login', { replace: true });
        }
      }
    };

    validateSession();

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        validateSession();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Also check when window regains focus
    const handleFocus = () => {
      validateSession();
    };
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [navigate, location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="admin-panel">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <meta name="description" content="Protected admin interface - not for public indexing" />
      </Helmet>
      <div className="admin-sidebar">
        <div className="admin-logo">
          <h2>RL Esports Admin</h2>
        </div>
        <nav className="admin-nav">
          <Link
            to="/admin"
            className={location.pathname === '/admin' ? 'nav-link active' : 'nav-link'}
          >
            Dashboard
          </Link>
          <Link
            to="/admin/matches"
            className={location.pathname.includes('/admin/matches') ? 'nav-link active' : 'nav-link'}
          >
            Matches
          </Link>
          <Link
            to="/admin/teams"
            className={location.pathname.includes('/admin/teams') ? 'nav-link active' : 'nav-link'}
          >
            Teams
          </Link>
          <Link
            to="/admin/players"
            className={location.pathname.includes('/admin/players') ? 'nav-link active' : 'nav-link'}
          >
            Players
          </Link>
          <Link
            to="/admin/leagues"
            className={location.pathname.includes('/admin/leagues') ? 'nav-link active' : 'nav-link'}
          >
            Leagues
          </Link>
        </nav>

        {/* Logout button at bottom of sidebar */}
        {isAuthenticated && (
          <div className="admin-logout">
            <button className="logout-button" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
      <div className="admin-content">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
